
export default {
  name: 'CertificationLayout',
}
